import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const ContainerPending = styled.div`
	margin: 10px 0;
`;

export const BoxModal = styled.div`
	background-color: #fff;
	border-radius: 8px;
	padding: 15px;
	width: 400px;
`;
